import { Button, Divider, Drawer, Stack, Typography } from "@mui/material";
import { FormEvent, ReactNode } from "react";
import LoadingButton from "src/components/Buttons/LoadingButton";

interface Props {
  open: boolean;
  onClose: () => void;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  children: ReactNode;
  loading: boolean;
  label: string;
}

const DrawerForm = ({
  onClose,
  open,
  children,
  handleSubmit,
  loading,
  label,
}: Props) => {
  return (
    <Drawer
      onClose={onClose}
      open={open}
      anchor="right"
      sx={{
        "& .MuiDrawer-paper": {
          width: 500,
          padding: 2,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        gap={2}
        component="form"
        onSubmit={handleSubmit}
        sx={{ flex: 1, overflow: "hidden" }}
      >
        <Stack sx={{ flex: 1, overflowY: "auto" }} gap={2}>
          <Stack gap={1}>
            <Typography variant="h5">{label}</Typography>
            <Divider />
          </Stack>
          {children}
        </Stack>
        <Stack direction={"row"} gap={1}>
          <LoadingButton type="submit" loading={loading} fullWidth>
            Submit
          </LoadingButton>
          <Button variant="secondary" onClick={() => onClose()} fullWidth>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default DrawerForm;
